const AppHost = {
  JMM: {
    code: "JMM",
    param: "BomPLxN9pE6hcVukeptLZg",
  },
  JTA: {
    code: "JTA",
    param: "wSdBkpYNs0yOseHvoudDZg",
  },
  IRA: {
    code: "IRA",
    param: "R4lnPyqLjE2n3yt0q3VAXA",
  },
  AMM: {
    code: "AMM",
    param: "4d11S352c9bA40faafeAX7",
  },
};
export default Object.freeze(AppHost);
